// src/components/create-project/ProjectForm/steps/Step1ProjectInfo.tsx
import { FC } from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { ProjectFormData } from '@/components/create-project/types/project';

interface StepProps {
  formData: ProjectFormData;
  updateField: (key: keyof ProjectFormData, value: any) => void;
  errors: Record<string, string>;
}

export const Step1ProjectInfo: FC<StepProps> = ({ formData, updateField, errors }) => {
  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <Label htmlFor="name">Project Name</Label>
        <div className="space-y-1">
          <Input
            id="name"
            value={formData.name}
            onChange={e => updateField('name', e.target.value)}
          />
          {errors.name && (
            <p className="text-sm text-red-500">{errors.name}</p>
          )}
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={formData.description}
          onChange={e => updateField('description', e.target.value)}
          rows={4}
        />
      </div>
    </div>
  );
};